module.exports = __webpack_public_path__ + "static/media/bolso (29).521ed867.jpg";